<template>
  <el-dropdown size="small" class="d2-mr" trigger="click">
    <span class="btn-text">
      <i class="el-icon-globe d2-mr-5" />
      {{ currentLang }}
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in languages"
        :key="item.code"
        @click.native="handleLangChange(item.code)"
      >
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import util from "@/libs/util";
import { UserLangService } from "@/api/ZQBasicsTable";
import { initI18n } from "@/lang";

export default {
  name: "d2-header-lang",
  data() {
    return {
      languages: [
        { code: "0", label: "中文" },
        { code: "1", label: "Tiếng Việt" },
        { code: "2", label: "English" }
      ],
      currentLang: "中文"
    };
  },
  async mounted() {
    // 🔥 第一步：先加载语言包
    await initI18n();

    // 🔥 第二步：语言包加载完，再读取本地语言并设置
    this.initLangFromCookie();
  },
  methods: {
    initLangFromCookie() {
      const languageCode = util.cookies.get("language");
      if (languageCode) {
        const targetLang = this.languages.find(
          item => item.code === languageCode
        );
        if (targetLang) {
          this.currentLang = targetLang.label;
          this.$i18n.locale = this.getLangType(languageCode);
        }
      }
    },

    getLangType(code) {
      const map = {
        0: "zh",
        1: "vi",
        2: "en"
      };
      return map[code] || "zh";
    },

    handleLangChange(code) {
      const lang = this.languages.find(item => item.code === code);
      this.currentLang = lang.label;
      this.$i18n.locale = this.getLangType(code);

      util.cookies.set("language", code);
      let data = {
        language: code,
        ID: util.cookies.get("uuid")
      };
      UserLangService(data).then(res => {
        console.log("用户语言保存成功", res);
      });

      console.log("✅ 语言切换成功：", code, this.$i18n.locale);
    }
  }
};
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/language/index.vue"
}
</vue-filename-injector>
